import React from "react";
import { Link } from "react-router-dom";
import styles from "./ChallengeStandard.module.css";

const ChallengeStandard = () => {
  return (
    <div className={styles.challengeBox}>
      <h4 className={styles.title}>Challenge This Standard Here</h4>
      <p className={styles.text}>
        Want to challenge this standard?
        <Link to="/challenge" className={styles.link}> Challenges Link</Link>
      </p>
    </div>
  );
};

export default ChallengeStandard;
